export enum AccessRoles {
  USER_ROLE_VIEW_COMMUNITY_DATA = "viewCommunityData",
  USER_ROLE_VIEW_CUSTOMER_DATA = "viewCustomerData"
}
